exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copyright { display: block; padding: 5px; text-align: center; position: absolute; bottom: 0; width: 100%; margin-top: 10px; background-color: #ababac; font-size: .8rem; color: white; font-weight: 300;}\n.page-content {\n    min-height: 100vh;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-portal/bf-portal.component.css
// module id = ../../../../../src/app/bf-portal/bf-portal.component.css
// module chunks = main